function AppleIcon() {
    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            className="block">
            <path
                fill="#000000"
                d="M 42.746094 33.36 C 41.711250 35.658750 41.212500 36.686250 39.881250 38.715000 C 38.017500 41.550000 35.389688 45.090000 32.140688 45.112500 C 29.250000 45.138281 28.504688 43.226250 24.577500 43.260000 C 20.654688 43.278750 19.837500 45.150000 16.942688 45.120000 C 13.690688 45.090000 11.204250 41.902688 9.340688 39.071250 C 4.128750 31.132688 3.577500 21.824688 6.798750 16.875000 C 9.078750 13.366688 12.682688 11.302688 16.068750 11.302688 C 19.518750 11.302688 21.686250 13.196250 24.536250 13.196250 C 27.303750 13.196250 28.987500 11.298750 32.977500 11.298750 C 35.992500 11.298750 39.180000 12.941250 41.460000 15.776250 C 34.004688 19.863750 35.216250 30.509688 42.746094 33.36 Z M 29.947500 8.130000 C 31.399688 6.266250 32.501250 3.638250 32.100000 0.960000 C 29.733750 1.121250 26.966250 2.632500 25.350000 4.590000 C 23.883750 6.375000 22.668750 9.022500 23.140688 11.583750 C 25.725000 11.666250 28.399688 10.124688 29.947500 8.130000 Z"></path>
        </svg>
    );
}
export default AppleIcon;
